import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RolesBoEnum } from '../../enum/role.enum';
import { ILoginState } from './login';
import { rolesBo } from '../../components/basic-page/utils-header';

const exampleStateSelector = createFeatureSelector<ILoginState>('login');

export const selectLoginData = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state
);

export const selectToken = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.authToken
);

export const selectEsito = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.esito || ''
);

export const selectFullName = createSelector(
  exampleStateSelector,
  (state: ILoginState) =>
    `${state.utente?.firstName || ''} ${state.utente?.lastName || ''}`
);

export const selectRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) =>
    state.utente?.profili.find((role) => {
      return Object.keys(rolesBo).includes(role);
    }) || ''
);

export const selectUser = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.utente
);

export const selectHasAdminRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.ADMIN)
);

export const selectHasRtRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.RT)
);

export const selectHasPclRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.PCL)
);

export const selectHasCeacRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.CEAC)
);

export const selectHasOrtRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.ORT)
);

export const selectHasVrtRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.VRT)
);

export const selectHasAppRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.APP)
);

export const selectHasAppRtRole = createSelector(
  exampleStateSelector,
  (state: ILoginState) => !!state.utente?.profili.includes(RolesBoEnum.APPRT)
);
export const selectResponseCambioPassword = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.responseCambioPassword
);
export const selectCodTipologiaRt = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.utente?.codTipologiaCp
);
export const selectUserRtAcronym = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.utente?.siglaRt
);
